import './file-download.scss';

import { Spin, Tooltip } from 'antd';
import { useState } from 'react';

import { Button } from '@/components/Shared/ui';
import { downloadFilesApi } from '@/integrations/index.api';
import { LoadingOutlined, ReloadOutlined } from '@/media/antd-icons';
import FileTextIcon from '@/media/icons/file-text.svg?react';
import RedDownloadIcon from '@/media/icons/red-download.svg?react';
import { handleError } from '@/services/handleError';
import { saveBase64AsImage, saveBase64AsPDF } from '@/services/helpers/files';

interface IProps {
  prevStateTitle: string;
  iconOnly?: boolean;
  fileLink: string;
  oldDownloadMethod?: boolean;
  preDownloadEvent?: () => Promise<void>;
  resend?: {
    resendFile: () => void;
    isResendLoading: boolean;
  };
}

const FileDownload: React.FC<IProps> = ({
  prevStateTitle,
  iconOnly = false,
  fileLink,
  oldDownloadMethod,
  preDownloadEvent,
  resend
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownloadClick = async () => {
    setLoading(true);
    try {
      if (preDownloadEvent) await preDownloadEvent();
      if (oldDownloadMethod === true) {
        const link = document.createElement('a');
        link.href = fileLink;
        link.download = prevStateTitle;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const response = await downloadFilesApi.downloadBankFile(fileLink);

        if (response.name.endsWith('.pdf')) {
          saveBase64AsPDF(response.base64, prevStateTitle);
        } else {
          saveBase64AsImage(
            response.base64,
            prevStateTitle + `.${response.name.split('.').pop()}`
          );
        }
      }
    } catch (error) {
      handleError(error);
    }
    setLoading(false);
  };

  return (
    <a
      className={`file-download ${!iconOnly ? 'file-download--with-title' : ''}`}
      href={fileLink}
      target="_blank"
      onClick={(event) => {
        event.preventDefault();
        handleDownloadClick();
      }}
      title="Скачать загруженный файл"
    >
      {!iconOnly && (
        <>
          <FileTextIcon />
          <p className="file-download__text">{prevStateTitle}</p>
        </>
      )}
      {resend && (
        <Tooltip title="Отправить еще раз">
          <Button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              resend.resendFile();
            }}
            size="small"
            isSquare
            isLoading={resend.isResendLoading}
          >
            {!resend.isResendLoading && <ReloadOutlined />}
          </Button>
        </Tooltip>
      )}
      {loading ? <Spin indicator={<LoadingOutlined />} /> : <RedDownloadIcon />}
    </a>
  );
};

export default FileDownload;
